import React from 'react';

const Sidebar = ({ activePage, setActivePage }) => {
  const menuItems = [
    { id: 'divider-1', type: 'divider', label: 'Data' },
    { id: 'contacts', label: 'Contacts', icon: '👥' },
    { id: 'companies', label: 'Companies', icon: '🏢' },
    { id: 'opportunities', label: 'Opportunities', icon: '💼' },
    { id: 'quotes', label: 'Quotes', icon: '📄' },
    { id: 'quote-association-gaps', label: 'Quote Associations', icon: '🔗' },
    { id: 'divider-2', type: 'divider', label: 'Sync Configuration' },
    { id: 'field-config', label: 'Field Configuration', icon: '🔗' },
    { id: 'value-mappings', label: 'Value Mappings', icon: '🔄' },
    { id: 'lookup-mappings', label: 'Lookup Mappings', icon: '👤' },
  ];

  return (
    <aside className="sidebar">
      <div className="sidebar-header">
        <h1>🔄 Sync Monitor</h1>
      </div>
      <nav className="sidebar-nav">
        {menuItems.map((item) => {
          if (item.type === 'divider') {
            return (
              <div key={item.id} className="sidebar-divider">
                <span>{item.label}</span>
              </div>
            );
          }
          return (
            <button
              key={item.id}
              className={`nav-item ${activePage === item.id ? 'active' : ''}`}
              onClick={() => setActivePage(item.id)}
            >
              <span className="nav-icon">{item.icon}</span>
              <span className="nav-label">{item.label}</span>
            </button>
          );
        })}
      </nav>
    </aside>
  );
};

export default Sidebar;
